export enum WhatsappServices {
    OFFICIAL = 'api-official',
    BAILEYS = 'baileys',
}